import axios from 'axios';
import React from 'react';
import {Button, Grid, CircularProgress, Typography, Divider, Stack, Box, TextField, FormControlLabel, Switch, RadioGroup, Radio, FormControl, FormLabel, Select, MenuItem, LinearProgress, CardHeader, CardContent, Card} from '@mui/material';
import BasicTable2 from "../tools/BasicTable2";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as ETVConstants from '../ETVConstants';
import { Delete, Edit, Save, Lock, CheckCircle, Block, Photo, Add, Person } from '@mui/icons-material';
import CardAccessMgmt from './CardAccessMgmt';
import Autocomplete from '@mui/material/Autocomplete';
import Phototaker from '../tools/Phototaker';
import MessageDialog from '../tools/MessageDialog';
import PhotoThumb from '../tools/PhotoThumb';

class CardMgmt extends React.Component {

  constructor(props) {
    super(props);
    this.uploadPhotos = this.uploadPhotos.bind(this);
    this.closeInfoMessage = this.closeInfoMessage.bind(this);
  }

  state = {
    locations:[],
    cards:[],
    locationsLoaded:false,
    cardsLoaded: false,
    selected_card_id:undefined,
    selected_location_id:undefined,

    // dialog state
    window: '',
    action: undefined,
    card_id: '',
    name: '',
    active: true,

    // validity controls
    validityMode: 'never',   // 'never' | 'temporary' | 'date'
    tempMinutes: 15,         // one of [5,15,30,60,120,240]
    dateLocal: '',           // 'YYYY-MM-DDTHH:mm' for <input type="datetime-local">

    info_title: undefined,
    info_message: undefined,
  }

  componentDidUpdate() {
    if(!this.state.cardsLoaded && !this.state.cardsLoading && this.state.selected_location_id) {
      this.loadCards();
    }
  }

  componentDidMount() {
    this.loadLocations();
  }

  loadLocations() {
    this.setState({loadingLocations:true});
    var url = ETVConstants.getServerBase()+"/floor_access?action=get_locations&user_id="+this.props.user_id;
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          var locID = undefined;
          if(result.list.length===1) {
            locID = result.list[0].location_id;
          }
          this.setState({
            locations: result.list,
            locationsLoaded: true,
            loadingLocations:false,
            selected_location_id: locID,
          });
        },
        (error) => {
          this.setState({
            locations:[],
            locationsLoaded: false,
            loadingLocations:false,
            error
          });
        }
      )
  }

  loadCards() {
    this.setState({cardsLoading:true});
    var accessToken = localStorage.getItem("etv.access_token");
    var reqUserID = localStorage.getItem("etv.user_id");
    var url = ETVConstants.getServerBase()+"/floor_access?action=get_cards&location_id="+this.state.selected_location_id+"&issuer_id="+reqUserID;
    //console.log("load cards url="+url);
    fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(JSON.stringify(result));
          this.setState({
            cards: result.list,
            cardsLoaded: true,
            cardsLoading: false,
          });
        },
        (error) => {
          this.setState({
            cards:[],
            cardsLoaded: false,
            cardsLoading: false,
            error
          });
        }
      )
  }


  getCard( cardID) {
    for(var i=0; i<this.state.cards.length; i++) {
      if(this.state.cards[i].card_id===cardID) {
        return this.state.cards[i];
      }
    }
    return null;
  }

  showWindow(divID, show) {
    show?this.setState({window:divID}):this.setState({window:''});
  }

	showInfoMessage(title,msg,isSpinning) {
		this.setState({window:'message_div',info_type:'info',info_title:title,info_message:msg,spinning:isSpinning});
	}

  showSuccessMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'success',info_title:title,info_message:msg,spinning:false});
	}

	showErrorMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
	}

  closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false});
  }


  addCard() {
    this.setState({
      window: 'add_card_div',
      action: 'add_card',
      card_id:'',
      name: '',
      active:true,
      validityMode: 'never',
      tempMinutes: 15,
      dateLocal: '',
    });
  }

    editCard(cardID) {
      const card = this.state.cards.find(c => c.card_id === cardID);
      if (card) {
        const existingValidUntil = (card.valid_until || '').trim(); // expect '' or 'yyyy-MM-dd HH:mm +0000'
        // If a valid_until exists, prefill the date picker in local time and set mode 'date'
        let validityMode = 'never';
        let dateLocal = '';
        if (existingValidUntil !== '') {
          const dt = this.parseEtvUtcStringToDate(existingValidUntil); // Date (UTC-based)
          if (dt) dateLocal = this.toLocalDatetimeLocalValue(dt);      // convert to local 'YYYY-MM-DDTHH:mm'
          validityMode = 'date';
        }
        this.setState({
          window:'add_card_div',
          card_id: card.card_id,
          action: 'update_card',
          name: card.name,
          active: card.active,
          validityMode,
          tempMinutes: 15,
          dateLocal,
        });
      }
    }


    // Format Date -> 'yyyy-MM-dd HH:mm +0000' (force UTC)
    formatUtcForServer(dateObj) {
      const pad = (n) => (n<10? '0'+n : ''+n);
      const y = dateObj.getUTCFullYear();
      const m = pad(dateObj.getUTCMonth()+1);
      const d = pad(dateObj.getUTCDate());
      const hh = pad(dateObj.getUTCHours());
      const mm = pad(dateObj.getUTCMinutes());
      return `${y}-${m}-${d} ${hh}:${mm} +0000`;
      // We always send +0000 (UTC)
    }

    // Parse 'yyyy-MM-dd HH:mm ±HHMM' -> Date in UTC
    parseEtvUtcStringToDate(s) {
      const re = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}) ([+-]\d{4})$/;
      const m = s.match(re);
      if (!m) return null;
      const [_, ys, ms, ds, hs, mins, off] = m;
      const y = parseInt(ys, 10);
      const mo = parseInt(ms, 10);
      const d = parseInt(ds, 10);
      const h = parseInt(hs, 10);
      const mi = parseInt(mins, 10);
      const sign = off[0] === '-' ? -1 : 1;
      const offHours = parseInt(off.substring(1,3), 10);
      const offMins  = parseInt(off.substring(3,5), 10);
      const totalOffsetMin = sign * (offHours*60 + offMins);

      // Date.UTC gives time as if in UTC; adjust by offset to get actual UTC ms
      const msUTC = Date.UTC(y, mo-1, d, h, mi) - (totalOffsetMin * 60 * 1000);
      return new Date(msUTC);
    }

    // Convert Date -> 'YYYY-MM-DDTHH:mm' in local time for <input type="datetime-local">
    toLocalDatetimeLocalValue(dateObj) {
      const pad = (n) => (n<10? '0'+n : ''+n);
      const y = dateObj.getFullYear();
      const m = pad(dateObj.getMonth()+1);
      const d = pad(dateObj.getDate());
      const hh = pad(dateObj.getHours());
      const mm = pad(dateObj.getMinutes());
      return `${y}-${m}-${d}T${hh}:${mm}`;
    }

    // Compute valid_until param based on the current UI state
    computeValidUntilParam() {
      const { validityMode, tempMinutes, dateLocal } = this.state;

      if (validityMode === 'never') {
        return '';
      }

      if (validityMode === 'temporary') {
        const now = new Date();
        const expiry = new Date(now.getTime() + tempMinutes * 60 * 1000);
        return this.formatUtcForServer(expiry);
      }

      // validityMode === 'date' -> parse local datetime-local, convert to UTC string
      if (!dateLocal) return ''; // if empty, treat as never
      // dateLocal like 'YYYY-MM-DDTHH:mm' (local)
      const localDate = new Date(dateLocal); // interpreted as local time by browser
      if (isNaN(localDate.getTime())) return '';

      return this.formatUtcForServer(localDate);
    }

    submitAddCard() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      const { card_id, name, active } = this.state;
      const validUntilToSend = this.computeValidUntilParam();
      var url = ETVConstants.getServerBase()+"/floor_access?action=add_card";
      url+="&card_id="+encodeURIComponent(card_id);
      url+="&name="+encodeURIComponent(name);
      url+="&active="+active;
      url+="&issuer_id="+reqUserID;
      url+="&location_id="+this.state.selected_location_id;
      url+="&valid_until="+encodeURIComponent(validUntilToSend);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); 
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    deleteCard(cardID) {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/floor_access?action=delete_card";
      url+="&card_id="+cardID;
      //console.log("delete URL="+url);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); // reload table
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    updateCard() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      const { card_id, name, active } = this.state;

      const validUntilToSend = this.computeValidUntilParam();

      var url = ETVConstants.getServerBase()+"/floor_access?action=update_card";
      url+="&card_id="+card_id;
      url+="&name="+encodeURIComponent(name);
      url+="&issuer_id="+reqUserID;
      url+="&active="+active;
      url+="&location_id="+this.state.selected_location_id;
      url+="&valid_until="+encodeURIComponent(validUntilToSend);
      //console.log("update card URL="+url);

      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); // reload table
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    showAccess(cardID) {
      this.setState({window:'card_access_div',selected_card_id:cardID});
    }

    formatEtvUtcToLocal(str) {
      if (!str || str.trim() === '') {
        return ETVConstants.trans("forever");
      }
      // Expecting "yyyy-MM-dd HH:mm ±HHMM"
      const re = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}) ([+-]\d{4})$/;
      const m = str.match(re);
      if (!m) return str; // fallback: show raw

      const [_, ys, ms, ds, hs, mins, off] = m;
      const y = parseInt(ys, 10);
      const mo = parseInt(ms, 10);
      const d = parseInt(ds, 10);
      const h = parseInt(hs, 10);
      const mi = parseInt(mins, 10);

      const sign = off[0] === '-' ? -1 : 1;
      const offHours = parseInt(off.substring(1, 3), 10);
      const offMins = parseInt(off.substring(3, 5), 10);
      const totalOffsetMin = sign * (offHours * 60 + offMins);

      // Calculate true UTC
      const msUTC = Date.UTC(y, mo - 1, d, h, mi) - (totalOffsetMin * 60 * 1000);
      const dt = new Date(msUTC);

      // Compare with now
      const now = new Date();
      if (dt.getTime() <= now.getTime()) {
        return ETVConstants.trans("expired"); // 👈 show "expired"
      }

      // Display in local time
      return dt.toLocaleString(); // or format explicitly
    }

    dataURLtoBlob = async (dataUrl) => {
      if (dataUrl instanceof Blob) return dataUrl; // already Blob
      const res = await fetch(dataUrl);
      return await res.blob();
    };

    async uploadPhotos(locationID, cardID, photos) {
      try {
        if (!Array.isArray(photos) || photos.length !== 3) {
          throw new Error("Need exactly 3 photos");
        }
        if (!locationID && locationID !== 0) throw new Error("Missing location_id");
        if (!cardID) throw new Error("Missing card_id");

        this.showInfoMessage("info", ETVConstants.trans("uploading"), true);

        const accessToken = localStorage.getItem("etv.access_token");
        const reqUserID   = localStorage.getItem("etv.user_id");
        const url         = ETVConstants.getServerBase() + "/access_mgmt_image_uploader";

        // Convert dataURLs into Blobs
        const [b1, b2, b3] = await Promise.all(photos.map(p => this.dataURLtoBlob(p)));

        // Build formData exactly as backend expects
        const formData = new FormData();
        formData.append("card_id", String(cardID));
        formData.append("location_id", String(locationID));
        formData.append("photo1", b1, "photo1.jpg");
        formData.append("photo2", b2, "photo2.jpg");
        formData.append("photo3", b3, "photo3.jpg");

        // Don’t set Content-Type manually → Axios will handle it with boundary
        const config = {
          headers: {
            "user_id": String(reqUserID),
            "access_token": accessToken
          }
        };

        const response = await axios.post(url, formData, config);

        if (response.status === 200) {
          this.showSuccessMessage("upload", "uploaded to cloud storage");
          this.setState({cardsLoaded:false});
          return response.data;
        } else {
          throw new Error("Upload failed with status " + response.status);
        }

      } catch (error) {
        this.showErrorMessage("error", "error: " + (error.response?.data?.error || error.message));
        throw error;
      }
    }

    addPhoto(cardID) {
        this.setState({window:'add_photo_div',selected_card_id:cardID});
    }

    sendFace(cardID) {
      this.showInfoMessage("face","submitting the face images",true);
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/floor_access?action=send_face";
      url+="&card_id="+encodeURIComponent(cardID);
      url+="&location_id="+this.state.selected_location_id;
      //console.log("send face URL="+url);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.showSuccessMessage("sent","submitted");
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

	  render() {
      var selectedCard = null;
      if(this.state.selected_card_id !== null) {
        selectedCard =  this.getCard(this.state.selected_card_id);
      }
      const columnsDataCard= [
        { title: ETVConstants.trans('card_id'), field: 'card_id'},
        { title: ETVConstants.trans('name'), field: 'name'},
        { title: ETVConstants.trans('active'), field: '', render: rowData => (rowData.active?<CheckCircle color='success'/>:<Block color='error'/>)},
        { title: ETVConstants.trans("valid_until"), field: 'valid_until', render: rowData => (rowData.valid_until && rowData.valid_until.trim() !== '' ? this.formatEtvUtcToLocal(rowData.valid_until): ETVConstants.trans('forever') )},
        { title: ETVConstants.trans("access"), field: '', render: rowData => (<Button disabled={!rowData.active} variant='contained' size='small' color='primary' startIcon={<Lock/>} onClick={()=>this.showAccess(rowData.card_id)}>{ETVConstants.trans("access")}</Button>)},
        { title: ETVConstants.trans("edit"), field: '', render: rowData => (<IconButton variant='contained' size='small' color='primary' onClick={()=>this.editCard(rowData.card_id)}><Edit/></IconButton>)},
        { title: ETVConstants.trans("add_photo"), field: '', render: rowData => (<IconButton variant='contained' size='small' color='primary' onClick={()=>this.addPhoto(rowData.card_id)}><Photo/></IconButton>)},
        { title: ETVConstants.trans("send_faces"), field: '', render: rowData => (<IconButton variant='contained' size='small' color='primary' onClick={()=>this.sendFace(rowData.card_id)}><Person/></IconButton>)},
        { title: ETVConstants.trans("delete"), field: '', render: rowData => (<IconButton variant='contained' size='small' color='error' onClick={()=>this.deleteCard(rowData.card_id)}><Delete/></IconButton>)},
      ];
		  return (
        <div>
          <div style={{ padding: 20, width: 400 }}>
            <Autocomplete
              options={this.state.locations}
              getOptionLabel={(option) => option.name}
              value={
                this.state.locations.find(
                  (loc) => loc.location_id === this.state.selected_location_id
                ) || null
              }
              onChange={(event, newValue) => {
                this.setState({
                  selected_location_id: newValue ? newValue.location_id : '',
                  cardsLoaded: false,
                });
              }}
              isOptionEqualToValue={(option, value) =>
                option.location_id === value.location_id
              }
              loading={this.state.loadingLocations} 
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={ETVConstants.trans("select_location")}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {this.state.loadingLocations ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </div>

          {this.state.cardsLoading && <LinearProgress/>}

          {this.state.selected_location_id?
          <Card elevation={2}>
            <CardHeader
              title={ETVConstants.trans("cards")}
              action={
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => this.addCard()}
                  sx={{ mt: 1 }}
                >
                  {ETVConstants.trans("add_card")}
                </Button>
              }
              sx={{ pb: 1 }}
            />
            <CardContent>
              <BasicTable2 data={this.state.cards} columns={columnsDataCard} title={""} pageSize={10} allow_search={true} />
            </CardContent>
          </Card>
          :
          <span/>
          }

          <Dialog
            open={this.state.window === 'card_access_div'}
            maxWidth="md"
            fullWidth={true}
            onClose={() => this.setState({ window: '' })}
            aria-labelledby="add-card-dialog-title"  >
            <DialogContent>
              <CardAccessMgmt location_id={this.state.selected_location_id} card_id={this.state.selected_card_id} />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ window: '' })} color="primary">{ETVConstants.trans("close")}</Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.window === 'add_photo_div'}
            maxWidth="md"
            fullWidth
            onClose={() => this.setState({ window: '' })}
            aria-labelledby="add-card-dialog-title"
          >
            <DialogTitle id="add-card-dialog-title">
              {ETVConstants.trans("add_update_face_photos")}
            </DialogTitle>

            <DialogContent dividers>
              <Grid container spacing={3}>
                {/* Left: current photos */}
                <Grid item xs={12} md={5}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {ETVConstants.trans("current_photos")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {ETVConstants.trans("you_can_keep_or_capture_new_photos")}
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                      <PhotoThumb src={selectedCard?.photo1} alt="Photo 1" />
                      <PhotoThumb src={selectedCard?.photo2} alt="Photo 2" />
                      <PhotoThumb src={selectedCard?.photo3} alt="Photo 3" />
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {ETVConstants.trans("tip_good_lighting_look_straight_ahead_and_align_your_face_inside_the_guide")}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>

                {/* Right: camera / capture */}
                <Grid item xs={12} md={7}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {ETVConstants.trans("capture_3_new_photos")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {ETVConstants.trans("press_capture_three_times_then_press_upload_to_save")}
                    </Typography>

                    <Box sx={{ mt: 1 }}>
                      <Phototaker
                        location_id={this.state.selected_location_id}
                        card_id={this.state.selected_card_id}
                        photosTaken={this.uploadPhotos} 
                      />
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => this.setState({ window: '' })}>
                {ETVConstants.trans("close")}
              </Button>
            </DialogActions>
          </Dialog>    

          <Dialog
            open={this.state.window === 'add_card_div'}
            maxWidth="sm"
            fullWidth={true}
            onClose={() => this.setState({ window: '' })}
            aria-labelledby="add-card-dialog-title"
            >
            <DialogTitle id="add-card-dialog-title">
              {this.state.action === 'add_card' ? ETVConstants.trans('add_card') : ETVConstants.trans('edit_card')}
            </DialogTitle>

            <DialogContent dividers>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label={ETVConstants.trans("card_id")}
                variant="outlined"
                fullWidth
                autoFocus
                value={this.state.card_id || ''}
                onChange={(e) => this.setState({ card_id: e.target.value })}
                disabled={this.state.action === 'update_card'}
              />
              <TextField
                label={ETVConstants.trans("name")}
                variant="outlined"
                fullWidth
                value={this.state.name || ''}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
              <FormControlLabel
                control={
                <Switch
                  checked={Boolean(this.state.active)}
                  onChange={(e) => this.setState({ active: e.target.checked })}
                />
                }
                label={ETVConstants.trans("active")}
              />

              {/* Validity controls */}
              <FormControl component="fieldset" sx={{ mt: 1 }}>
                <FormLabel component="legend">{ETVConstants.trans("validity") || "validity"}</FormLabel>
                <RadioGroup
                  row
                  value={this.state.validityMode}
                  onChange={(e) => this.setState({ validityMode: e.target.value })}
                >
                <FormControlLabel value="never" control={<Radio />} label={ETVConstants.trans("never_expires") || "never"} />
                <FormControlLabel value="temporary" control={<Radio />} label={ETVConstants.trans("temporary") || "temporary"} />
                <FormControlLabel value="date" control={<Radio />} label={ETVConstants.trans("specific_date") || "specific date"} />
                </RadioGroup>
              </FormControl>

              {this.state.validityMode === 'temporary' && (
                <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>{ETVConstants.trans("duration") || "duration"}</FormLabel>
                <Select
                  value={this.state.tempMinutes}
                  onChange={(e) => this.setState({ tempMinutes: Number(e.target.value) })}
                >
                  <MenuItem value={5}>5 minutes</MenuItem>
                  <MenuItem value={15}>15 minutes</MenuItem>
                  <MenuItem value={30}>30 minutes</MenuItem>
                  <MenuItem value={60}>1 hour</MenuItem>
                  <MenuItem value={120}>2 hours</MenuItem>
                  <MenuItem value={240}>4 hours</MenuItem>
                </Select>
                </FormControl>
              )}

              {this.state.validityMode === 'date' && (
                <TextField
                label={ETVConstants.trans("valid_until") || "valid until (your local time)"}
                type="datetime-local"
                variant="outlined"
                fullWidth
                value={this.state.dateLocal}
                onChange={(e) => this.setState({ dateLocal: e.target.value })}
                InputLabelProps={{ shrink: true }}
                />
              )}
              </Box>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => this.setState({ window: '' })} color="primary">
              {ETVConstants.trans("close")}
              </Button>
              <Button
              onClick={() =>
                this.state.action === 'add_card' ? this.submitAddCard() : this.updateCard()
              }
              color="primary"
              startIcon={<Save />}
              variant="contained"
              >
              {this.state.action === 'add_card'
                ? ETVConstants.trans("save")
                : ETVConstants.trans("update")}
              </Button>
            </DialogActions>
          </Dialog>

          <MessageDialog spinning={this.state.spinning} type={this.state.info_type} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message} />

        </div>
      );
    }
}

export default CardMgmt;
